import { DefaultThunk } from "stores";
import { UpdateEffect } from "stores/modules/entities.room.effects";
import { undoRedoReorderEffects } from "stores/modules/entities.room.effects/operations";

export type OrderEffectRecord = {
  kind: "change-effect-index";
  id: string;
  beforeIndex: number;
  afterIndex: number;
  item: UpdateEffect;
};

export const undoOrderEffect =
  (history: OrderEffectRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    if (!roomId) return;

    dispatch(
      undoRedoReorderEffects(
        roomId,
        history.id,
        history.beforeIndex,
        history.item
      )
    );
    return;
  };

export const redoOrderEffect =
  (history: OrderEffectRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    if (!roomId) return;

    dispatch(
      undoRedoReorderEffects(
        roomId,
        history.id,
        history.afterIndex,
        history.item
      )
    );
    return;
  };
